import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import GppGoodIcon from "@mui/icons-material/GppGood";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PersonIcon from "@mui/icons-material/Person";
import RouteIcon from "@mui/icons-material/Route";
import VerifiedIcon from "@mui/icons-material/Verified";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Typography,
  Stack,
} from "@mui/material";
import React from "react";
import { isMobile, isDesktop } from "react-device-detect";
import deporte from "../assets/deporte.jpg";
import deposito from "../assets/deposito.jpg";
import edificio from "../assets/edificio.jpg";
import educacion from "../assets/educacion.jpg";
import industria from "../assets/industria.jpg";
import local from "../assets/local.jpg";
import ContactForm from "../components/ContactForm";
import FormularioBomberos from "../components/FormularioBomberos";
import { info } from "../helpers/Info";
import "../styles/Habilitaciones.css";
import WhatsAppButton from "../components/WhatsAppButton";
import fondo from "../assets/planilla-extintor-h.jpg";
import fondo2 from "../assets/planilla-extintor.jpg";

const LandingHabilitaciones = () => {
  return (
    <Box
      className="habilitaciones"
      sx={{ paddingTop: isMobile ? "70.4px":"86px", bgcolor: "#fff" }}
    >
      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          backgroundImage: !isMobile ? `url(${fondo})` : `url(${fondo2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: !isDesktop ? "column" : "row",
          alignItems: "center",
          color: "white",
          justifyContent: "center",
          textAlign: "center",
          /* paddingLeft: isMobile ? ".3rem" : "1rem",
          paddingRight: isMobile ? ".3rem" : "1rem", */
          maxWidth: "100%",
          height: !isDesktop ? "50vh" : "calc(100vh - 86px) ",
          maxHeight: "100vh",
          zIndex: 10,
        }}
      >
        <Stack direction="row" justifyContent="center">
          <Box
            sx={{
              zIndex: 10,
              textAlign: "center",
              width: !isDesktop ? "100%" : "40%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Stack
              sx={{ height: isDesktop ? "50%" : "100%", maxWidth:'700px' }}
              justifyContent={isDesktop ? "space-between" : "center"}
              alignItems="center"
            >
              <Typography
                variant="h1"
                sx={{
                  maxWidth: isDesktop ? "94%" : isMobile ? "98%" : "90%",
                  /* fontWeight: 700, */
                  textAlign: isDesktop ? "start" : "center",
                }}
              >
                ¿Estas Necesitando La Habilitación De Bomberos Para tu Local?
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  maxWidth: isDesktop ? "94%" : isMobile ? "96%" : "90%",
                  textAlign: !isDesktop ? "center" : "start",
                }}
              >
                Nos encargamos de la gestión del trámite de tu local de
                principio a fin. Sin importar en que punto del país te
                encuentres.
              </Typography>
            </Stack>
            {!isDesktop && (
              <Stack
                sx={{ width: "96%", margin: '0 auto' }}
                direction="row"
                justifyContent="center"
                
              >
                <Button
                  variant="contained"
                  color="success"
                  sx={{
                    mt: 1,
                    fontWeight: "bold",
                    zIndex: 10,
                    width: "20rem",
                    
                  }}
                  href={"/habilitacion-de-bomberos#contacto"}
                >
                  quiero asesoramiento
                </Button>
              </Stack>
            )}
          </Box>
          {isDesktop && (
            <Box sx={{ width: "30%" }}>
              {" "}
              <FormularioBomberos id="bomberos" />{" "}
            </Box>
          )}
        </Stack>
        {/* Overlay negro */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1,
          }}
        />
      </Box>
      {!isDesktop && (
        <ContactForm
          placeholder="Información de utilidad: uso del local, superficie en m2, dirección y localidad"
          id="bomberos"
        />
      )}

      {/* Servicios */}
      <Container sx={{ py: 6 }}>
        <Typography
          variant="h4"
          mb="2rem"
          mt={!isMobile ? "2rem" : 0}
          textTransform="uppercase"
          gutterBottom
        >
          Nuestros Servicios
        </Typography>
        <Grid
          container
          sx={{
            alignItems: "center",
            justifyContent: "center",
            marginTop: isMobile ? "2rem" : "4rem",
            width: "auto",
          }}
          spacing={isMobile ? 0 : 4}
        >
          {info.map((item) => {
            return (
              item.id === 1 &&
              item.servicios.map((service) => {
                return (
                  service.id > 1 && (
                    <Grid
                      sx={{
                        backgroundImage: `url(${service.imagen})`,
                        height: "250px",
                        width: isMobile ? "96%" : "100%",
                        position: "relative",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        margin: "0 auto",
                        paddingLeft: "0 !important",
                      }}
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      p={0}
                      key={service.id}
                    >
                      {/* Overlay negro */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          backgroundColor: "rgba(0,0,0,0.7)",
                          zIndex: 1,
                        }}
                      />
                      <Box
                        sx={{
                          position: "relative",
                          zIndex: 10,
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          flexDirection: "column",
                          height: "100%",
                          width: "100%",
                          margin: "auto auto",
                        }}
                        textAlign="center"
                      >
                        {service.id == 2 ? (
                          <RouteIcon
                            sx={{ color: "#fafafa" }}
                            fontSize="large"
                          />
                        ) : service.id == 3 ? (
                          <NotificationsActiveIcon
                            sx={{ color: "#fafafa" }}
                            fontSize="large"
                          />
                        ) : (
                          <ExitToAppIcon
                            sx={{ color: "#fafafa" }}
                            fontSize="large"
                          />
                        )}
                        <Typography
                          variant="h6"
                          textTransform="uppercase"
                          color="#fff"
                          sx={{ mt: 1 }}
                        >
                          {service.nombre}
                        </Typography>
                        <Button
                          variant="outlined"
                          sx={{
                            mt: 1,
                            fontWeight: "bold",
                            color: "#fafafa",
                            borderColor: "#fafafa",
                          }}
                          href={
                            service.id == 2
                              ? "/bomberos#sistemas-hidraulicos"
                              : service.id == 3
                              ? "/bomberos#sistemas-deteccion"
                              : "/bomberos#planes-evacuacion"
                          }
                        >
                          + Info
                        </Button>
                      </Box>
                    </Grid>
                  )
                );
              })
            );
          })}
        </Grid>
      </Container>

      <Box py="2rem" sx={{ bgcolor: "#fafafa" }}>
        <Container>
          <Typography variant="h4" textTransform="uppercase" gutterBottom>
            ¿Es obligatoria la habilitación de bomberos?
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontSize: isMobile ? "1rem" : "1.23rem" }}
          >
            El Decreto 372/023 establece que toda edificación destinada a
            actividades comerciales, industriales o de servicios debe contar con
            habilitación vigente de Bomberos. No cumplir con esta obligación
            puede acarrear serias consecuencias, como multas económicas,
            clausura del local y responsabilidad legal. En caso de que ocurra un
            siniestro y el local no cuente con la habilitación, el propietario
            podría enfrentar no solo sanciones civiles, sino también
            responsabilidad penal. El incumplimiento compromete la continuidad
            del negocio y pone en riesgo la seguridad de las personas.
          </Typography>
        </Container>
      </Box>

      {/* edificaciones */}
      <Box py="2rem" sx={{ bgcolor: "#fff3e0" }}>
        <Typography
          variant="h4"
          mb="2rem"
          textTransform="uppercase"
          gutterBottom
        >
          ¿Que edificaciones requieren esta habilitación?
        </Typography>
        <Container>
          <Grid container spacing={2}>
            {[
              {
                label: "Locales Comerciales",
                img: local,
              },
              {
                label: "Viviendas | Oficinas",
                img: edificio,
              },
              {
                label: "Industrias",
                img: industria,
              },
              {
                label: "Depositos",
                img: deposito,
              },
              {
                label: "Clubes deportivos",
                img: deporte,
              },
              {
                label: "Centros de estudio",
                img: educacion,
              },
            ].map((edif, index) => (
              <Grid item xs={12} sm={6} md={4} key={index} mb=".5rem">
                <Box
                  sx={{
                    position: "relative",
                    height: 200,
                    borderRadius: 2,
                    overflow: "hidden",
                    backgroundImage: `url(${edif.img})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                  }}
                >
                  {/* Overlay negro */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0,0,0,0.5)",
                      zIndex: 1,
                    }}
                  />

                  {/* Texto por encima del overlay */}
                  <Typography
                    variant="h6"
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      textTransform: "uppercase",
                      textAlign: "center",
                      px: 2,
                    }}
                  >
                    {edif.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Beneficios */}
      <Box sx={{ bgcolor: "#f9f9f9" }}>
        <Container sx={{ py: 6 }}>
          <Typography
            variant="h4"
            mb={isMobile ? "2rem" : "4rem"}
            textTransform="uppercase"
            gutterBottom
          >
            Beneficios de elegirnos
          </Typography>
          <Grid container spacing={4}>
            {[
              {
                label: "Experiencia Especializada",
                icon: <VerifiedIcon fontSize="large" color="success" />,
              },
              {
                label: "Cumplimiento Normativo",
                icon: <GppGoodIcon color="success" fontSize="large" />,
              },
              {
                label: "Atención Personalizada",
                icon: <PersonIcon color="success" fontSize="large" />,
              },
            ].map((benefit, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <Box textAlign="center">
                  {benefit.icon}
                  <Typography
                    variant="h6"
                    textTransform="uppercase"
                    sx={{ mt: 1 }}
                  >
                    {benefit.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
      {/* Formulario de Contacto */}
      <Divider />
      <WhatsAppButton
        id="btn-whatsapp-bomberos"
        srOnly="Whatsapp bomberos"
        message="Necesito asesoramiento para una habilitación de bomberos"
      />
      {/* <ContactForm id="bomberos" /> */}
    </Box>
  );
};

export default LandingHabilitaciones;
